import Axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import swal from "sweetalert";
import { Empty } from "antd";

import { Table } from "antd";
import { Excel } from "antd-table-saveas-excel";

export default function ShopWiseItemsReport() {
  const [headers, setHeaders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemWiseReport, setItemWiseReport] = useState([]);

  const [isEmpty, setIsEmpty] = useState(false);

  const {
    user: { accessToken, refreshToken },
  } = useSelector((state) => state.auth);

  const getReportData = async (url, setData, setHeader) => {
    setLoading(true);
    const { data } = await Axios.get(
      `${process.env.REACT_APP_API_URL}/report/${url}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          refreshToken: refreshToken,
        },
      }
    );
    if (!data.error) {
      if (data.finalData.length) {
        setData(data.finalData);
        const singleData = data.finalData[0];

        const makeHeader = [];

        for (let key in singleData) {
          makeHeader.push({
            title: key === "item" ? "Product Name" : key,
            dataIndex: key,
            key: key,
            width: 200,
            fixed: key === "item" && "left",
          });
        }
        setHeader(makeHeader);
        setIsEmpty(false);
      } else {
        setIsEmpty(true);
        setData([]);
        setHeader([]);
      }
    } else {
      swal({
        title: "Something went wrong",
        icon: "error",
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    getReportData("productReportStoreWise", setItemWiseReport, setHeaders);
  }, []);

  return (
    <div>
      <div className="card p-5 mb-5">
        <div className="row justify-content-between align-items-end">
          <div className="col-md-8">
            <h2>Shop wise Products Sales </h2>
          </div>

          {itemWiseReport.length > 0 && (
            <div className="col-md-2">
              <button
                className="btn btn-primary w-100"
                onClick={() => {
                  const excel = new Excel();
                  excel
                    .addSheet("test")
                    .addColumns(headers)
                    .addDataSource(itemWiseReport)
                    .saveAs("Shopwise Product Sales.xlsx");
                }}
              >
                Download
              </button>
            </div>
          )}
        </div>
      </div>

      {isEmpty ? (
        <Empty />
      ) : (
        <Table
          loading={loading}
          columns={headers}
          dataSource={itemWiseReport}
          scroll={{ x: 1300 }}
          bordered={false}
          className="table  table-head-bg table-borderless table-vertical-center rounded"
        />
      )}
    </div>
  );
}
